const {Component} = require("react");
const PropTypes = require("prop-types");
const moment = require("moment");
const userStore = require("stores/UserStore");
const Calendar = require("components/widgets/Calendar");
const Booking = require("components/backend/upcoming-bookings/Booking");
const store = require("stores/BookingsStore");
const {decodeObservable} = require("helpers/object");
const {onSameDay} = require("helpers/moment");

class UpcomingBookings extends Component {

	static get propTypes() {
		return {
			viewAs: PropTypes.string
		};
	}

	static get defaultProps() {
		return {
			viewAs: "bookable"
		};
	}

	constructor(props) {
		super(props);

		this.state = {
			date: moment().format("YYYY-MM-DD")
		};
	}

	onDateChange = (date) => {
		this.setState({date});
	};

	getBookingViewAs(booking) {
		return booking.booker.id === userStore.get("id") ?
			"booker" :
			"bookable";
	}

	get bookings() {
		const dateRef = moment().format("YYYY-MM-DD") === this.state.date ?
			moment() : moment(this.state.date).startOf("day");

		return decodeObservable(store.collection).filter(booking => {
			const from = moment(booking.from);

			return onSameDay(dateRef, from) && from.isSameOrAfter(dateRef) && this.isConcrete(booking);
		});
	}

	get nextBookings() {
		const all = decodeObservable(store.collection);

		if (all.length < 1) return [];

		const filter = (booking) => moment(booking.from).isAfter(moment()) && this.isConcrete(booking);
		const sorter = (a, b) => moment(a.from).isAfter(moment(b.from)) ? 1 : -1;

		return all
			.filter(filter)
			.sort(sorter)
			.slice(0, 4);
	}

	isConcrete(booking) {
		return (booking.status === 'booked' || booking.status === 'accepted');
	}

	renderCalendar() {
		const bookings = decodeObservable(store.collection);
		const dayClassName = (date) => {
			const dateMoment = moment(date);

			if (dateMoment.isBefore(moment().startOf("day"))) {
				return;
			}

			for (let i = 0; i < bookings.length; i++) {
				if (onSameDay(dateMoment, moment(bookings[i].from)) && this.isConcrete(bookings[i])) {
					return "has-bookings";
				}
			}
		};


		return (
			<Calendar min={moment().toISOString()} value={this.state.date}
								dayClassNameFn={dayClassName}
								handleChange={this.onDateChange}/>
		);
	}

	renderBookings() {
		const bookings = this.bookings;
		const date = moment(this.state.date);

		if (bookings.length === 0) {
			return (<p className="no-bookings">Der er ingen kommende bookinger den {date.format("DD[.] MMMM YYYY")}.</p>);
		}

		return bookings.map(booking => {
			return (
				<Booking key={booking.id} viewAs={this.getBookingViewAs(booking)} {...booking}/>
			);
		});
	}

	renderFallback() {
		const today = this.bookings;
		const bookings = this.nextBookings;

		if (today.length > 0 || bookings.length < 1) return;

		const bookingsMarkup = bookings.map((booking, index) => (
			<Booking key={index} viewAs={this.getBookingViewAs(booking)} {...booking}/>
		));

		return (
			<React.Fragment>
				<div className="top-bar">
					<p>Næste undervisninger</p>
				</div>

				<div className="lessons scrollbar">
					<div className="gradient"></div>
					{bookingsMarkup}
				</div>
			</React.Fragment>
		);
	}

	render() {
		const lessonsClass = [
			'lessons',
			'scrollbar',
			this.bookings.length < 1 ? 'empty' : null
		];

		return (
			<div className="upcomming-classes">
				{this.renderCalendar()}

				<div className="top-bar">
					<p>Kommende undervisninger</p>
				</div>

				<div className={lessonsClass.join(' ')}>
					<div className="gradient"></div>
					{this.renderBookings()}
				</div>

				{this.renderFallback()}
			</div>
		)
	}

}

module.exports = UpcomingBookings;



// WEBPACK FOOTER //
// ./resources/js/components/backend/upcoming-bookings/UpcomingBookings.js